import { render } from "./turnos.vue?vue&type=template&id=0ca17d85&scoped=true"
import script from "./turnos.vue?vue&type=script&lang=js"
export * from "./turnos.vue?vue&type=script&lang=js"

import "./turnos.vue?vue&type=style&index=0&id=0ca17d85&scoped=true&lang=css"

import exportComponent from "C:\\Users\\yordis.escorcia\\Downloads\\relojito\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ca17d85"]])

export default __exports__